// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","jcGrey300":"#c9cccf","emailBadge":"EmailBadge__emailBadge","email":"EmailBadge__email"};